import { createReducer, on } from '@ngrx/store';
import { deleteSubActionEvent } from '../Actions/carousel.actions';
import { initialState } from "../State/carousel.state";
import { formEventChildEvent } from "../Actions/carousel.actions";

export const carouselReducer = createReducer(
  initialState,
  on(deleteSubActionEvent, (state, { path, index }) => ({
    ...state,
    deleteEvent: { path, index }
  })),
  on(formEventChildEvent, (state, payload) => ({
    ...state,
    formEventChildData: { ...payload }
  })),
);
